export default function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-background-50 border border-background-200/50 rounded-2xl p-8 md:p-12">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
              关于我们
            </h2>
            <p className="text-sm text-foreground-400">51黑料吃瓜网 · 全网吃瓜第一站</p>
          </div>

          <div className="space-y-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            <p>
              <strong className="text-foreground-900">51黑料吃瓜网</strong>成立于2024年，是国内领先的在线吃瓜内容聚合平台。我们致力于为吃瓜群众提供最新、最全、最热的娱乐八卦、网红黑料、社会热点等海量免费内容。
            </p>
            <p>
              平台汇聚<strong className="text-foreground-900">51吃瓜在线观看</strong>、<strong className="text-foreground-900">51黑料在线观看</strong>、<strong className="text-foreground-900">吃瓜在线视频</strong>、<strong className="text-foreground-900">黑料在线播放</strong>等多种内容形式，覆盖娱乐圈、网红圈、综艺、影视、音乐、直播、社会热点等七大领域，内容总量超过5000+条，每日活跃用户超过10万人。
            </p>
            <p>
              我们的团队由资深娱乐编辑、新媒体运营和技术开发人员组成，秉承"快、全、真"的内容理念，7×24小时追踪全网热点，确保每一位来到51黑料吃瓜网的吃瓜群众都能第一时间获取最新鲜的瓜。
            </p>
            <p>
              51黑料吃瓜网全面适配移动端，无需下载安装任何应用，打开手机浏览器即可畅享高清流畅的观看体验。我们相信，吃瓜不需要门槛，好内容应该触手可及。
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-10 mt-8 pt-8 border-t border-background-200/50">
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading text-primary-500">10W+</div>
              <div className="text-xs text-foreground-500 mt-1">日活用户</div>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading text-accent-500">5000+</div>
              <div className="text-xs text-foreground-500 mt-1">内容资源</div>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading text-secondary-600">7大</div>
              <div className="text-xs text-foreground-500 mt-1">内容板块</div>
            </div>
            <div className="w-px h-8 bg-background-300"></div>
            <div className="text-center">
              <div className="text-xl md:text-2xl font-heading text-primary-500">24h</div>
              <div className="text-xs text-foreground-500 mt-1">全天更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}